import type { PropsWithChildren, ReactNode } from "react";

import { cn } from "@krea/shared/utils";

import DetailsItem from "../item";

interface DetailsCardProps {
  className?: string;
  title?: ReactNode;
}

const DetailsCard = ({
  className,
  title,
  children,
}: PropsWithChildren<DetailsCardProps>) => {
  return (
    <section
      className={cn(
        "details-container rounded-xl border border-gray-200 bg-white h-full w-full p-4 xl:p-6",
        className,
      )}
    >
      <DetailsItem title={title}>{children}</DetailsItem>
    </section>
  );
};

export default DetailsCard;
